import React, { useState, useEffect } from "react";
import { useTransition, animated } from "react-spring";
import { stepStyles } from "./formStyles";

export const HowCanWeReachYou = ({ formData, setForm, navigation }) => {
  const [error, setError] = useState(false);
  const [isSubmitted, setIsSubmitted] = useState(false);
  const { email } = formData;
  const [isVisible] = useState(true);

  const transition = useTransition(isVisible, {
    from: { opacity: 0, transform: "translate3d(300px,0px,0)" },
    enter: { opacity: 1, transform: "translate3d(0,0px,0)" },
  });

  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const [query, setQuery] = useState(window.location.search);

  useEffect(() => {
    const currentParams = Object.fromEntries([...new URLSearchParams(window.location.search)]);
    setQuery(currentParams);
  }, []);
  console.log(query);

  const submitForm = () => {
    let dataToSend = {
      ...formData,
      utm_campaign: query.utm_campaign ? query.utm_campaign : "Corp Website - Request a Mortgage Consultation-default",
      ...query,
    };
    console.log(dataToSend);
    fetch(
      "https://services.leadconnectorhq.com/hooks/iSTRaFEUKfa6zYcK9qDQ/webhook-trigger/88e35379-8557-4d7d-bebc-f8550696e5a8",
      {
        method: "POST",
        body: JSON.stringify(dataToSend),
        headers: {
          "Content-Type": "application/json",
          Accept: "application/json",
        },
      },
    )
      .then((response) => {
        console.log(response);
        if (response.status === 200) {
          console.log("submitted");
          setIsSubmitted(true);
        }
      })
      .catch((error) => {
        console.log(error);
      });
  };

  const checkForNextStep = () => {
    if (emailValidator(formData.email) && phoneValidator(formData.phone)) {
      submitForm();
    } else {
      setError(true);
      console.log("error");
    }
  };

  const emailValidator = (input) => {
    const regexpTest =
      /^(([^<>()\]\\.,;:\s@"]+(\.[^<>()\]\\.,;:\s@"]+)*)|(".+"))@(([0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    const isValid = regexpTest.test(input) && input.length > 0;

    return isValid;
  };

  function phoneValidator(input) {
    const regexpTest = /^(\+\d{1,2}\s)?\(?\d{3}\)?[\s.-]?\d{3}[\s.-]?\d{4}$/;

    const isValid = input.length > 0 && regexpTest.test(input);

    return isValid;
  }

  function formatPhoneNumber(input) {
    var phoneNumber = input.replace(/\D/g, "");
    var match = phoneNumber.match(/^(\d{3})(\d{3})(\d{4})$/);

    if (match) {
      phoneNumber = "(" + match[1] + ") " + match[2] + "-" + match[3];
    }

    return phoneNumber;
  }

  console.log(formatPhoneNumber(formData.phone));

  return (
    <div className={stepStyles.page}>
      <div className={stepStyles.content}>
        {transition((style, item) =>
          item ? (
            <animated.div style={style} className={stepStyles.panel}>
              {isSubmitted ? (
                <div className="flex w-full max-w-2xl flex-col items-center gap-6 py-8 text-center">
                  <h1 className={stepStyles.title}>Thank you.</h1>
                  <p className="max-w-xl text-lg font-medium leading-relaxed text-brand-ink md:text-xl">
                    Your consultation request has been received. A team member will reach out shortly.
                  </p>
                </div>
              ) : (
                <>
                  <h1 className={stepStyles.title}>How can we reach you?</h1>
                  <div className="mt-6 flex w-full max-w-xl flex-col gap-6 text-left">
                    <div className="w-full">
                      <label
                        htmlFor="phone"
                        className="mb-2 block text-sm font-semibold uppercase tracking-[0.14em] text-gray-satan"
                      >
                        Phone Number
                      </label>
                      <div className="w-full">
                        <input
                          name="phone"
                          value={formatPhoneNumber(formData.phone)}
                          onChange={setForm}
                          id="phone"
                          type="tel"
                          maxLength="10"
                          className={stepStyles.input}
                          placeholder="555-555-5555"
                        />
                      </div>
                    </div>

                    <div className="w-full">
                      <label
                        htmlFor="email"
                        className="mb-2 block text-sm font-semibold uppercase tracking-[0.14em] text-gray-satan"
                      >
                        Email
                      </label>
                      <div className="w-full">
                        <input
                          name="email"
                          value={email}
                          onChange={setForm}
                          id="email"
                          className={stepStyles.input}
                          placeholder="email@email.com"
                        />
                      </div>
                    </div>

                    {error ? (
                      <p className="mt-1 text-sm font-semibold text-red-error">please fill out an answer</p>
                    ) : null}
                  </div>

                  <div className="mt-6 flex w-full max-w-xl justify-center">
                    <div className="w-full">
                      <button className={`${stepStyles.buttonAlt} w-full`} onClick={() => checkForNextStep()}>
                        Schedule a Consultation
                      </button>
                    </div>
                  </div>

                  <p className="mx-auto mt-6 max-w-3xl text-center text-2xs leading-relaxed text-gray-fourdee md:text-xs">
                    By clicking the ‘Schedule a Consultation’ button above, I authorize Warp Speed Mortgage to contact
                    me using an automated dialing system, even if the telephone number is a cellular phone or other
                    service for which the party is charged. I understand that I am not required to provide this consent
                    in order to obtain goods or services from Warp Speed Mortgage. I agree to receive disclosures and
                    communications in electronic form and I confirm that I have a working computer system and an
                    internet website browser to view this webpage and this loan inquiry form. I agree that Warp Speed
                    Loans may contact me by mail, telephone (mobile devices including SMS and MMS) or email in
                    connection with my request even if my telephone number or email address appears on a Warp Speed
                    Mortgage internal Do Not Call / Do Not Email List, a State or National Do Not Call Registry, a Do
                    Not Loans internal Do Not Call / Do Not Email List, a State or National Do Not Call Registry, a Do
                    Not E-Mail list, or any other Do Not Contact List.
                  </p>
                </>
              )}
            </animated.div>
          ) : null,
        )}
      </div>
    </div>
  );
};
